"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _avlComponents = require("@availabs/avl-components");

var _Container = _interopRequireDefault(require("./components/Container"));

var _amsAcceptInvite = _interopRequireDefault(require("../wrappers/ams-accept-invite"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _amsAcceptInvite["default"])(function (_ref) {
  var password = _ref.password,
      verify = _ref.verify,
      update = _ref.update,
      canSubmit = _ref.canSubmit,
      handleSubmit = _ref.handleSubmit;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full flex-1 flex items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    Title: "Accept Invite"
  }, /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-2"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "password",
    className: "block font-bold"
  }, "Password"), /*#__PURE__*/_react["default"].createElement(_avlComponents.Input, {
    type: "password",
    id: "password",
    value: password,
    autoFocus: true,
    onChange: function onChange(v) {
      return update({
        password: v
      });
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-2"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "verify",
    className: "block font-bold"
  }, "Verify Password"), /*#__PURE__*/_react["default"].createElement(_avlComponents.Input, {
    type: "password",
    id: "verify",
    value: verify,
    onChange: function onChange(v) {
      return update({
        verify: v
      });
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-2"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    type: "submit",
    buttonTheme: "buttonLargePrimaryBlock",
    disabled: !canSubmit
  }, "accept")))));
});

exports["default"] = _default;